import BaseType from "../BaseType";
import Guid from "../Guid";
import EducatorSiteItem from "./EducatorSiteItem";

export default class EducatorSiteHeader extends BaseType {
  Items: EducatorSiteItem[] = [];
}
